module.exports = __webpack_public_path__ + "static/img/SketchPng48fbec55ef659f3c59d4a704a42dba0bc376c1190392bf089569e522fdcd0515.f0730878.png";